// Component displaying for Page title

import React from "react";
import { Row } from "react-bootstrap";
import './PageTitle.css';

const PageTitle = (props) => {

    // UI to render
    return (
    <Row className="pageTitle">
        <h2 className="pageTitleText">{props.titleName}</h2>
    </Row>
    )
};

export default PageTitle;
